import { Button, FormControlLabel, Grid, RadioGroup, Radio, Typography } from "@material-ui/core";
import { SaveOutlined } from "@material-ui/icons";
import { ErrorMessage, Field, useFormikContext } from "formik";
import { TextField } from 'formik-material-ui';
import { TypeInfo } from "helpers/enums";
import * as yup from "yup";
import { ticketTypeSchema } from "../TicketTypeContext";


let TicketTypeForm = () => {
    type TicketType = yup.InferType<typeof ticketTypeSchema>;

    let form = useFormikContext<TicketType>();


    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="name"
                        label="Name"
                        variant="outlined"
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12}>
                    <RadioGroup
                        row
                        value={form.values.typeInfo}
                        onChange={(e) => { form.setFieldValue('typeInfo', e.target.value) }}
                    >
                        <FormControlLabel value={TypeInfo.Delivery} control={<Radio />} label={TypeInfo.Delivery} />
                        <FormControlLabel value={TypeInfo.Product} control={<Radio />} label={TypeInfo.Product} />
                    </RadioGroup>
                    <ErrorMessage name="typeInfo">
                        {msg => <Typography variant="caption" color="error">{msg}</Typography>}
                    </ErrorMessage>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs />
                <Grid item>
                    <Button type="submit" color="secondary" variant="contained">
                        <SaveOutlined />&nbsp;Save
                    </Button>
                </Grid>
            </Grid>
        </>
    )
}

export default TicketTypeForm;